// extracted by mini-css-extract-plugin
module.exports = {"facebook__btn":"Register_facebook__btn__1q4EY","google__btn":"Register_google__btn__2Ub8k"};